import { render, staticRenderFns } from "./addPackageTask.vue?vue&type=template&id=09165b60&"
import script from "./addPackageTask.vue?vue&type=script&lang=js&"
export * from "./addPackageTask.vue?vue&type=script&lang=js&"
import style0 from "./addPackageTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09165b60')) {
      api.createRecord('09165b60', component.options)
    } else {
      api.reload('09165b60', component.options)
    }
    module.hot.accept("./addPackageTask.vue?vue&type=template&id=09165b60&", function () {
      api.rerender('09165b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addPackageTask.vue"
export default component.exports